import useResizeObserver from "@react-hook/resize-observer";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useNetlifySDK } from "./use_netlify_sdk.js";

export interface WindowDimensions {
  height: number;
  width: number;
}

export const useWindowSizeObserver = (
  onChange?: (dimensions: WindowDimensions) => void,
) => {
  const target = useRef(document.documentElement);
  const [dimensions, setDimensions] = useState<{
    height: number;
    width: number;
  }>({ height: -1, width: -1 });

  useLayoutEffect(() => {
    const { height, width } = target.current.getBoundingClientRect();

    if (dimensions.height !== height || dimensions.width !== width) {
      setDimensions({ height, width });
    }
  }, [dimensions.height, dimensions.width, setDimensions, target]);

  useResizeObserver(target, (entry) => {
    const { height, width } = entry.contentRect;

    if (dimensions.height !== height || dimensions.width !== width) {
      setDimensions({ height, width });
    }
  });

  useEffect(() => {
    if (typeof onChange === "function") {
      onChange(dimensions);
    }
  }, [dimensions, onChange]);
};

export const useWindowResizer = () => {
  const sdk = useNetlifySDK();

  useWindowSizeObserver(sdk.requestDimensions);
};
